import { CommissioningStatusEnum } from '@bo-client/activation-management/shared/models/commissioningModel';
import { StatusDefinition } from '../status.model';
import { COMMON_REQUEST_STATUS_DEFINITIONS } from './common.status-definitions';

/** Inbetriebnahme (`CommissioningRequest.state`). */
export const COMMISSIONING_STATUS_DEFINITIONS: readonly StatusDefinition[] = [
  ...COMMON_REQUEST_STATUS_DEFINITIONS,
  // Nur Inbetriebnahme: `GridRegistrationStatusEnum` kennt diesen Wert nicht.
  {
    value: CommissioningStatusEnum.InstallationCompleted,
    defaultLabel: 'Installation fertiggestellt',
    defaultColor: 'rgba(178,140,252,0.89)'
  },
  {
    value: CommissioningStatusEnum.PendingAppointment,
    defaultLabel: 'Warten auf Wunschtermin',
    defaultColor: '#e7ce06'
  },
  {
    value: CommissioningStatusEnum.ChimneySweepConfirmationRequested,
    defaultLabel: 'Bestätigung durch Schornsteinfeger angefragt',
    defaultColor: '#71dde3'
  },
  {
    value: CommissioningStatusEnum.FeedbackNeededByChimneySweep,
    defaultLabel: 'Rückfrage durch Schornsteinfeger',
    defaultColor: '#f0b429'
  },
  {
    value: CommissioningStatusEnum.DefectReported,
    defaultLabel: 'Mangel gemeldet',
    defaultColor: '#fd7e14'
  },
  {
    value: CommissioningStatusEnum.WaitingForOrder,
    defaultLabel: 'Warten auf Bestellung',
    defaultColor: '#71dde3'
  },
  { value: CommissioningStatusEnum.Commissioned, defaultLabel: 'Beauftragt', defaultColor: '#71dde3' },
  {
    value: CommissioningStatusEnum.TechnicalReview,
    defaultLabel: 'Technische Prüfung erfolgt',
    defaultColor: '#71dde3'
  },
  {
    value: CommissioningStatusEnum.NAVSent,
    defaultLabel: 'Netzanschlussvertrag versendet',
    defaultColor: '#71dde3'
  },
  // Kein Prozessschritt setzt diesen Status, nur „Status ändern“.
  { value: CommissioningStatusEnum.Cancelled, defaultLabel: 'Storniert', defaultColor: '#e99aa6' }
];
